export default "__VITE_ASSET__DtHAnYTj__"